import {dataFetcher} from "../../services/dataGuetter/dataFetcher";

export async function getAllTypeRapport():Promise<TypeRapport[]>{
    const res:any = await dataFetcher(`type_rapports`, {method:'get'})
    return res["hydra:member"];
}